var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wxdialecticalchart" }, [
    _c("div", { staticClass: "title" }, [_vm._v("中医辩证分型")]),
    _c("div", {
      style: { width: "100%", height: "590px" },
      attrs: { id: "dialectical" }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }